import { defineStore } from "pinia"
import http from "~/services/http"

interface IBookmarkParams extends IErrorAndSuccessCallbacks {
  params: { identifier: number; type: string }
}

export const useSmartPageStore = defineStore("smartPageStore", {
  state: () => ({
    value: null as null | any,
  }),

  actions: {
    checkBookmarked({ params, successCallback, errorCallback }: IBookmarkParams) {
      http.get({
        url: `v1/user/favourites/${params.identifier}`,
        params: {
          type: params.type,
        },
        successCallback: (ctx) => {
          successCallback && successCallback(ctx)
        },
        errorCallback: (ctx) => {
          errorCallback && errorCallback(ctx)
        },
      })
    },

    bookmarkPage({ params, successCallback, errorCallback }: IBookmarkParams) {
      http.post({
        url: "v1/user/favourites",
        body: params,
        successCallback: (ctx) => {
          successCallback && successCallback(ctx)
        },
        errorCallback: (ctx) => {
          errorCallback && errorCallback(ctx)
        },
      })
    },

    removeBookmark({ params, successCallback, errorCallback }: IBookmarkParams) {
      http.delete({
        url: `v1/user/favourites/${params.identifier}`,
        body: {
          type: params.type,
        },
        successCallback: (ctx) => {
          successCallback && successCallback(ctx)
        },
        errorCallback: (ctx) => {
          errorCallback && errorCallback(ctx)
        },
      })
    },
  },
})
